{
  "name": "ekowitryna-esq-calculator",
  "version": "0.0.29",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build:lib": "ng build ekowitryna-ui",
    "build:app": "ng build",
    "build": "npm run build:lib && npm run build:app",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "doc": "npx compodoc -p tsconfig.app.json -s",
    "lib:local": "node scripts/switch-to-local.js",
    "lib:npm": "node scripts/switch-to-npm.js",
    "lib:status": "node scripts/check-lib-status.js",
    "lib:check": "node scripts/check-gitlab-package.js"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.4",
    "@angular/cdk": "^20.2.8",
    "@angular/common": "^20.3.4",
    "@angular/compiler": "^20.3.4",
    "@angular/core": "^20.3.4",
    "@angular/forms": "^20.3.4",
    "@angular/localize": "^20.3.4",
    "@angular/platform-browser": "^20.3.4",
    "@angular/platform-browser-dynamic": "^20.3.4",
    "@angular/router": "^20.3.4",
    "@angular/service-worker": "^20.3.4",
    "@ekowitryna/ui": "20.1.3-dev83",
    "@fontsource-variable/mulish": "^5.2.6",
    "@fortawesome/angular-fontawesome": "^0.15.0",
    "@fortawesome/fontawesome-free": "^6.6.0",
    "@fortawesome/fontawesome-svg-core": "^6.6.0",
    "@fortawesome/free-solid-svg-icons": "^6.6.0",
    "@mobiletract/account-service-angular-client": "26.3.0-dev3",
    "@mobiletract/auth-service-angular-client": "26.3.0-dev3",
    "@mobiletract/esg-calculator-service-angular-client": "26.3.0-dev.b36",
    "@ngrx/component-store": "^18.1.0",
    "@ngrx/effects": "^18.1.0",
    "@ngrx/store": "^18.1.0",
    "@ngrx/store-devtools": "^18.1.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@primeng/themes": "^20.2.0",
    "@sentry/angular": "^8.35.0",
    "@sentry/tracing": "^7.119.2",
    "@tailwindcss/postcss": "^4.1.13",
    "@types/leaflet": "^1.9.18",
    "@zxing/browser": "^0.1.5",
    "@zxing/library": "^0.21.3",
    "@zxing/ngx-scanner": "^18.0.1",
    "angular-google-tag-manager": "^1.10.0",
    "angularx-qrcode": "^18.0.2",
    "chart.js": "^4.4.4",
    "echarts": "^5.5.1",
    "flag-icons": "^7.2.3",
    "html2canvas": "^1.4.1",
    "keycloak-angular": "^20.0.0",
    "keycloak-js": "^26.2.1",
    "leaflet": "^1.9.4",
    "ngx-echarts": "^18.0.0",
    "postcss": "^8.5.6",
    "primeicons": "^7.0.0",
    "primeng": "^20.2.0",
    "quill": "^2.0.2",
    "rxjs": "~7.8.0",
    "tslib": "^2.7.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.5",
    "@angular/cli": "^20.3.5",
    "@angular/compiler-cli": "^20.3.4",
    "@compodoc/compodoc": "^1.1.25",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.10.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ng-packagr": "^19.2.2",
    "tailwindcss": "^4.1.13",
    "typescript": "~5.8.3"
  }
}
